import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=4795bd32&scoped=true"
import script from "./LeftSideBar.vue?vue&type=script&lang=ts"
export * from "./LeftSideBar.vue?vue&type=script&lang=ts"
import style0 from "./LeftSideBar.vue?vue&type=style&index=0&id=4795bd32&prod&lang=css"
import style1 from "./LeftSideBar.vue?vue&type=style&index=1&id=4795bd32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4795bd32",
  null
  
)

export default component.exports